
    const data = {"name":"src/core/icons/spray-bottle","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M16.72 10.43C14.68 8.39 14.5 4.66 14.5 4H13v2H9V4H7c0-1.1.9-2 2-2h7v1c0 .08.04 4.63 1.78 6.37l-1.06 1.06M17 2v2h1V2h-1m-2 10c-2-2-2-5-2-5H9v2c0 1 0 1-1 2s-1 2-1 2v7c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-8Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            